import {
  get,
  post,
  put,
  patch,
  del,
  createQueryParams,
  getLocalStorageData,
} from "../axiosComponent";
import { serviceUrls } from "../constant";

// Utility function for common hostel room data preparation
const prepareRoomData = (data = {}) => {
  const profileDetails = getLocalStorageData("profileDetails");
  return {
    ...data,
    siteId: profileDetails["_SITE"],
    regionId: profileDetails["_REGION"],
    organizationId: profileDetails["_ORGANIZATION_"]["_ID"],
  };
};

// Room Management Services
export const getRoomsForHostel = async (data) => {
  return await get({
    url: serviceUrls.HOSTEL_SERVICE + "/room/list",
    params: createQueryParams(prepareRoomData(data)),
  });
};

export const getRoomDetails = async (entityId) => {
  return await get({
    url: serviceUrls.HOSTEL_SERVICE + "/room",
    params: createQueryParams({ entityId }),
  });
};

export const addRoom = async (data) => {
  return await post({
    url: serviceUrls.HOSTEL_SERVICE + "/room",
    data: prepareRoomData(data),
  });
};

export const updateRoom = async (data) => {
  return await put({
    url: serviceUrls.HOSTEL_SERVICE + "/room",
    data: prepareRoomData(data),
  });
};

export const deleteRoom = async (entityId) => {
  return await del({
    url: serviceUrls.HOSTEL_SERVICE + "/room",
    params: createQueryParams({ entityId }),
  });
};

export const updateRoomStatus = async (data) => {
  return await patch({
    url: serviceUrls.HOSTEL_SERVICE + "/room",
    params: createQueryParams(data),
  });
};

// Room Type Management Services
export const getRoomTypesList = async (data) => {
  return await get({
    url: serviceUrls.HOSTEL_SERVICE + "/room/type/list",
    params: createQueryParams(prepareRoomData(data)),
  });
};

export const getRoomTypeDetails = async (entityId) => {
  return await get({
    url: serviceUrls.HOSTEL_SERVICE + "/room/type",
    params: createQueryParams({ entityId }),
  });
};

export const addRoomType = async (data) => {
  return await post({
    url: serviceUrls.HOSTEL_SERVICE + "/room/type",
    data: prepareRoomData(data),
  });
};

export const updateRoomType = async (data) => {
  return await put({
    url: serviceUrls.HOSTEL_SERVICE + "/room/type",
    data: prepareRoomData(data),
  });
};

export const deleteRoomType = async (entityId) => {
  return await del({
    url: serviceUrls.HOSTEL_SERVICE + "/room/type",
    params: createQueryParams({ entityId }),
  });
};

export const updateRoomTypeStatus = async (data) => {
  return await patch({
    url: serviceUrls.HOSTEL_SERVICE + "/room/type",
    params: createQueryParams(data),
  });
};

// Room Facilities Management Services
export const getRoomFacilitiesList = async (data) => {
  return await get({
    url: serviceUrls.HOSTEL_SERVICE + "/room/facilities/list",
    params: createQueryParams(prepareRoomData(data)),
  });
};

export const getRoomFacilityDetails = async (entityId) => {
  return await get({
    url: serviceUrls.HOSTEL_SERVICE + "/room/facilities",
    params: createQueryParams({ entityId }),
  });
};

export const addRoomFacility = async (data) => {
  return await post({
    url: serviceUrls.HOSTEL_SERVICE + "/room/facilities",
    data: prepareRoomData(data),
  });
};

export const updateRoomFacility = async (data) => {
  return await put({
    url: serviceUrls.HOSTEL_SERVICE + "/room/facilities",
    data: prepareRoomData(data),
  });
};

export const deleteRoomFacility = async (entityId) => {
  return await del({
    url: serviceUrls.HOSTEL_SERVICE + "/room/facilities",
    params: createQueryParams({ entityId }),
  });
};

export const updateRoomFacilityStatus = async (data) => {
  return await patch({
    url: serviceUrls.HOSTEL_SERVICE + "/room/facilities",
    params: createQueryParams(data),
  });
};

// Room Users Management Services
export const getRoomUsersList = async (data) => {
  return await get({
    url: serviceUrls.HOSTEL_SERVICE + "/room/user/list",
    params: createQueryParams(prepareRoomData(data)),
  });
};

export const getRoomUserDetails = async (entityId) => {
  return await get({
    url: serviceUrls.HOSTEL_SERVICE + "/room/user",
    params: createQueryParams({ entityId }),
  });
};

export const addRoomUser = async (data) => {
  return await post({
    url: serviceUrls.HOSTEL_SERVICE + "/room/user",
    data: prepareRoomData(data),
  });
};

export const updateRoomUser = async (data) => {
  return await put({
    url: serviceUrls.HOSTEL_SERVICE + "/room/user",
    data: prepareRoomData(data),
  });
};

export const deleteRoomUser = async (entityId) => {
  return await del({
    url: serviceUrls.HOSTEL_SERVICE + "/room/user",
    params: createQueryParams({ entityId }),
  });
};

export const updateRoomUserStatus = async (data) => {
  return await patch({
    url: serviceUrls.HOSTEL_SERVICE + "/room/user",
    params: createQueryParams(data),
  });
};

// Hostel List for Dropdown (Optimized)
export const getHostelsListForDropdown = async (data) => {
  return await get({
    url: serviceUrls.HOSTEL_SERVICE + "/hostel/list",
    params: createQueryParams(prepareRoomData(data)),
  });
};
